/** Двумерный вектор (immutable рекомендован). */
export interface Vec2 {
  x: number;
  y: number;
}
export type ReadonlyVec2 = Readonly<Vec2>;

/** Branded number-типы для семантической безопасности. */
export type Seconds = number & { readonly __brand: "Seconds" };
export type Percent = number & { readonly __brand: "Percent" }; // 0..100
export type Normalized = number & { readonly __brand: "Normalized" }; // 0..1
export type EntityId = string & { readonly __brand: "EntityId" };

/** Factory functions для приведения сырых значений к branded типам. */
export const asSeconds = (n: number): Seconds => n as Seconds;
export const asPercent = (n: number): Percent => n as Percent;
export const asNormalized = (n: number): Normalized => n as Normalized;
export const asEntityId = (s: string): EntityId => s as EntityId;

/** Идентификаторы сцен в игре. */
export type SceneId = "splash" | "menu" | "game" | "bloom" | "settings" | "credits";

/** Прямоугольник границ [min, max] по каждой оси. */
export interface Bounds {
  x: readonly [number, number];
  y: readonly [number, number];
}
